// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"bg","hidden":"cg","preventTransition":"dg","divBgImg":"eg","loaded":"fg"};